// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__1KbVe","active":"Group_active__1RvMX","head":"Group_head__3yJ1y","menu":"Group_menu__3j7tG","link":"Group_link__2uBD8"};